/**
 * Determines if a value is a Buffer.
 */
export function isBuffer(value: any): value is Buffer {
  if (
    value.constructor &&
    typeof value.constructor.isBuffer === 'function'
  ) {
    return value.constructor.isBuffer(value);
  }

  return false;
}
